import { render, staticRenderFns } from "./VesselParticularsStakeholders.vue?vue&type=template&id=9717cd42&scoped=true&"
import script from "./VesselParticularsStakeholders.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsStakeholders.vue?vue&type=script&lang=js&"
import style0 from "./VesselParticularsStakeholders.vue?vue&type=style&index=0&id=9717cd42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9717cd42",
  null
  
)

export default component.exports